<div class="ddc-details-container">

  <!-- Regle -->
  <div class="ddc-info-block">
    <div class="row">
      <div class="col-12 ddc-block-with-content-right">
        <mat-icon [ngClass]="getValidationStatus('reglesJS', _campWithDetails)?.classLevel">
          <span class="material-icons">assignment</span>
        </mat-icon>
      </div>
    </div>
  </div>

  <!-- Liste de maitrises -->
  <div class="ddc-info-block">
    <ng-container
      *ngIf="_campWithDetails.campAdherentStaffs && _campWithDetails.campAdherentStaffs.length > 0; else noStaffsBlock">
      <div *ngFor="let campAdherentStaff of _campWithDetails.campAdherentStaffs" class="row">
        <div class="col-3">
          <span
            class="material-icons ddc-icon-beside-text">{{getDdcAdherentStaffRoleIcon(campAdherentStaff.roleStaff)}}</span>
          <span>{{campAdherentStaff.adherent.prenom}} {{campAdherentStaff.adherent.nom}}</span>
        </div>
        <div class="col-3">
          <div class="ddc-read-only-data-container">
            <span ddcLabel labelKey="appli.camp.carteDetails.adherentStaff.qualifications"></span>&nbsp;
            <span class="ddc-value">
              <span *ngIf="adherentsInformations">{{getAdherentQualificationLabel(campAdherentStaff.adherent.numero, adherentsInformations) || 'N/A'}}</span>
            </span>
          </div>
        </div>
        <div class="col-3">
          <div class="ddc-read-only-data-container">
            <span ddcLabel labelKey="appli.camp.carteDetails.adherentStaff.datePresence"></span>&nbsp;
            <span class="ddc-value">
              De {{convertToHumanDate(campAdherentStaff.dateDebutPresence)}}
              à {{convertToHumanDate(campAdherentStaff.dateFinPresence)}}
            </span>
          </div>
        </div>
        <div class="col-3">
          <div class="ddc-read-only-data-container">
            <span ddcLabel labelKey="appli.camp.carteDetails.adherentStaff.ageDebutCamp"></span>&nbsp;
            <span class="ddc-value">
              <span>{{getAgeAdherentAuDebutCamp(_campWithDetails, campAdherentStaff.adherent.dateNaissance) || 'N/A'}}</span>
            </span>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noStaffsBlock>
      <div class="row">
        <div class="col-12">
          <span>Aucun maitrise affecté</span>
        </div>
      </div>
    </ng-template>
  </div>


  <!-- Liste des messages bloquants -->
  <ng-container *ngIf="getCampAlertMessages(_campWithDetails); let campAlertMessages">
    <div class="ddc-info-block">
      <div class="row">
        <div *ngFor="let campAlertMessage of campAlertMessages" class="col-md-12">
      <span *ngIf="campAlertMessage.level == 'error'" class="ddc-error-message">
         <span><i class="material-icons">error</i></span>
        <span>{{campAlertMessage.message}}</span>
      </span>
          <span *ngIf="campAlertMessage.level == 'warn'" class="ddc-warning-message">
         <span><i class="material-icons">report_problem</i></span>
        <span>{{campAlertMessage.message}}</span>
      </span>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Lieu Principal -->
  <ng-container *ngIf="_campWithDetails && _campWithDetails.campLieuPrincipal && !_campWithDetails._isCampEnfant; let campLieuPrincipal">
    <div class="ddc-info-block">
      <div class="row">
        <div class="col-12">
          <div class="ddc-read-only-data-container">
            <span>Lieu Principal</span>&nbsp;
            <span class="ddc-value">{{getCampLieuAddress(campLieuPrincipal)}}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Liste d'avis -->
  <div class="ddc-info-block">
    <ng-container *ngIf="_campWithDetails && _campWithDetails.campAvis && _campWithDetails.campAvis.length > 0; else noAvisBlock">
      <ng-container *ngFor="let avis of PARAMETRES_AVIS_SGDF">
        <ng-container *ngIf="_campWithDetails._droitsUtilisateurCourant[avis.droit]">
          <div class="row" *ngIf="getCampAvisByType(_campWithDetails.campAvis, avis.typeAvis); let campAvis">
            <div class="col-md-2">
              <div class="ddc-read-only-data-container">
                <span ddcLabel labelKey="{{avis.labelKey}}"></span>&nbsp;
                <span class="ddc-value">{{campAvis.statut || 'N/A'}}</span>
              </div>
            </div>
            <div class="col-md-10">
              <div class="ddc-read-only-data-container">
                <span ddcLabel labelKey="bdd.campAvis.commentaire"></span>:&nbsp;
                <span class="ddc-value">{{campAvis.commentaire || 'N/A'}}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #noAvisBlock>
      <div class="row">
        <div class="col-12">
          <span>Aucun visa ou avis n'a été déclaré</span>
        </div>
      </div>
    </ng-template>
  </div>
</div>

